<template>
  <v-container class="pt-5" v-if="reloaded">
    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="310">
        <v-card>
          <v-card-title class="headline">{{$t("Something went wrong")}}</v-card-title>

          <v-card-text>{{$t("Tags not available")}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="tryAgain()">{{$t("Try again")}}</v-btn>
            <v-btn color="red darken-1" text @click="cancel()">{{$t("cancel")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row class="justify-center" id="cardSection" v-if="this.$store.state.register.page==1">
      <v-col cols="12" sm="12" md="12" xl="8">
        <h2 class="font-weight-light text-center">{{$t("Click on your favourite interests")}}</h2>
        <p
          class="font-weight-light text-center"
        >{{$t("Wenewz will generate your newsfeed based on these")}}</p>
        <v-row>
          <v-col v-for="card in cards" :key="card.id" :cols="$vuetify.breakpoint.smAndDown ? 6 : 4">
            <v-hover v-slot:default="{ hover }">
              <v-card
                :elevation="hover ? 10 : 2"
                :class="card.status=='selected'?'selectedCard':''"
                tile
                class="interestTagCard"
              >
                <v-img
                  :src="card.src"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                  v-on:click="changeIconStatus(card)"
                >
                  <v-card-actions class="justify-center">
                    <v-btn icon>
                      <!--Solid heart if selected-->
                      <v-icon
                        color="rgba(255, 0, 0, 0.8)"
                        dark
                        size="60"
                        v-if="card.status=='selected'"
                      >fas fa-heart</v-icon>
                    </v-btn>
                  </v-card-actions>

                  <v-card-title v-text="card.title"></v-card-title>
                </v-img>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="justify-center" id="cardSection" v-if="this.$store.state.register.page==2">
      <v-col cols="12" sm="12" md="12" xl="8">
        <h2 class="font-weight-light text-center">{{$t("Recommended news areas")}}</h2>
        <p class="font-weight-light text-center">{{$t("Suggested news area")}}</p>
        <v-row v-if="geoMain != ''">
          <v-col>
            <v-hover v-slot:default="{ hover }">
              <v-card
                :elevation="hover ? 10 : 2"
                :class="geoMain.status=='selected'?'selectedCard':''"
                tile
                class="interestTagCard"
                outlined
              >
                <div>
                  <v-img
                    :src="geoMain.src"
                    class="white--text"
                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    height="200px"
                    v-on:click="changeMainGeoIconStatus()"
                  >
                    <h2 class="mainCard" v-text="geoMain.title"></h2>
                  </v-img>
                  <!--Solid heart if selected-->

                  <v-card-title
                    class="justify-center"
                    v-if="geoMain.status=='selected'"
                  >{{$t("Selected")}}</v-card-title>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h2 class="font-weight-light text-center">{{$t("Other suggestions")}}</h2>
            <p
              class="font-weight-light text-center"
            >{{$t("You can also chose other geotags of interest")}}</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-for="card in geoSuggestions"
            :key="card.id"
            :cols="$vuetify.breakpoint.smAndDown ? 6 : 4"
          >
            <v-hover v-slot:default="{ hover }">
              <v-card
                :elevation="hover ? 10 : 2"
                :class="card.status=='selected'?'selectedCard':''"
                tile
                class="interestTagCard"
              >
                <v-img
                  :src="card.src"
                  class="white--text align-end"
                  gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                  height="200px"
                  v-on:click="changeGeoIconStatus(card)"
                >
                  <v-card-actions class="justify-center">
                    <v-btn icon>
                      <!--Solid heart if selected-->
                      <v-icon
                        color="rgba(255, 0, 0, 0.8)"
                        dark
                        size="60"
                        v-if="card.status=='selected'"
                      >fas fa-heart</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-card-title v-text="card.title"></v-card-title>
                </v-img>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-col class="ma-0 pa-0 pa-1">
      <v-card height="100%">
        <interestInfo @done="submitFrontPageFeed"></interestInfo>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import interestInfo from "./components/interestInfo/interestInfo";
import messages from "./modules/lang/export";
import { mapGetters, mapActions } from "vuex";
const axios = require("axios");
export default {
  components: {
    interestInfo,
  },
  i18n: { messages },
  data() {
    return {
      clientIp: "",
      cards: [], // objects with: id, status, title, src, flex,
      geoSuggestions: [],
      geoMain: "",
      dialog: false,
      reloaded: false,
    };
  },

  computed: {
    ...mapGetters(["isLoggedIn", "TagProfiles"]),
  },

  methods: {
    ...mapActions([
      "GET_INTERESTS",
      "GET_GEO",
      "UPDATE_TAGPROFILES",
      "GET_TAGPROFILES",
    ]),

    clear() {
      (this.clientIp = ""),
        (this.cards = []),
        (this.geoSuggestions = []),
        (this.geoMain = []),
        (this.dialog = false);
    },

    tryAgain() {
      this.clear();
      this.reloadPage();
    },

    cancel() {
      this.clear();
      setTimeout(() => this.$router.push("/"), 200);
    },

    changeIconStatus(card) {
      //Toggle the cards selected status
      //then check if the interest tag status is valid (user can add geo tags then)
      card.status = card.status == "selected" ? "" : "selected";
      let selectCount = 0;
      this.cards.forEach((element) => {
        selectCount =
          element.status == "selected" ? selectCount + 1 : selectCount;
      });
      let _status = selectCount > 0 ? "true" : "false";
      this.$store.commit("validateInterest", { status: _status });
    },

    changeGeoIconStatus(card) {
      //Toggle the cards selected status
      //then check if the geo tag status is valid (user can submit then)
      // console.log("changeGeoIconStatus ", card);
      card.status = card.status == "selected" ? "" : "selected";
      this.updateGeoStatus();
    },

    changeMainGeoIconStatus() {
      //Toggle the main geo suggestion selected status
      //then check if the geo tag status is valid (user can submit then)
      // console.log("changeMainGeoIconStatus ");
      this.geoMain.status = this.geoMain.status == "selected" ? "" : "selected";
      this.updateGeoStatus();
    },

    updateGeoStatus() {
      //If at least one geotag is selected => valid (allowed to submit)
      let selectCount = this.geoMain.status == "selected" ? 1 : 0;
      this.geoSuggestions.forEach((element) => {
        selectCount =
          element.status == "selected" ? selectCount + 1 : selectCount;
      });
      let _status = selectCount > 0 ? "true" : "false";
      this.$store.commit("validateGeo", { status: _status });
    },

    initInteresCards(data) {
      // console.log("Interest cards", data);
      this.cards = data.map((obj) => {
        let card = {
          status: "",
          flex: 6,
          src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
          id: obj.id,
          title: obj.Label,
        };
        return card;
      });
    },

    initGeoCards(data) {
      // console.log("Geo Cards", data);
      if (data.main) {
        this.geoMain = {
          status: "selected",
          flex: 6,
          src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
          id: data.main.id,
          title: data.main.Label,
        };
      }
      //TMP slice for testing (FIX API to give more relevant defaults)
      this.geoSuggestions = data.suggestions.slice(0, 40).map((obj) => {
        let card = {
          status: "",
          flex: 6,
          src: "https://cdn.vuetifyjs.com/images/cards/house.jpg",
          id: obj.id,
          title: obj.Label,
        };
        return card;
      });
    },

    getGeo(ip) {
      return new Promise((resolve, reject) => {
        this.GET_GEO({
          Lang:
            localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en",
          clientIP: ip ? ip : false,
        })
          .then((resp) => {
            // console.log("Geo is received: ", resp);
            this.initGeoCards(resp.data);
          })
          .catch((ex) => {
            console.error(ex);
          })
          .finally(() => {
            resolve(true);
          });
      });
    },

    getInterests() {
      return new Promise((resolve, reject) => {
        this.GET_INTERESTS({
          Lang:
            localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en",
        })
          .then((resp) => {
            this.initInteresCards(resp.data);
          })
          .catch((ex) => {
            console.error(ex);
          })
          .finally(() => {
            resolve(true);
          });
      });
    },

    //client IP API result is in plain text. parse this and return the IP
    parseUserLoc(text) {
      return new Promise((resolve, reject) => {
        let lines = text.split("\n");
        // console.log(lines);
        let ip = false;
        lines.forEach((elm) => {
          if (elm.includes("ip=")) {
            let _ip = elm.split("=")[1];
            if (_ip) {
              ip = _ip;
            }
          }
        });
        if (ip != false) {
          resolve(ip);
        } else {
          reject(false);
        }
      });
    },

    getUserIP() {
      return new Promise((resolve, reject) => {
        fetch("https://www.cloudflare.com/cdn-cgi/trace").then((res) => {
          return res
            .text()
            .then(function (text) {
              // console.log("IP ", text);
              resolve(text);
            })
            .catch((ex) => reject(ex));
        });

        /*
        fetch("https://api.ipify.org?format=json")
          .then(x => x.json())
          .then(({ ip }) => {
            // console.log("IP", ip);
          });
          */
      });
    },

    reloadPage() {
      window.location.reload();
    },

    async submitFrontPageFeed() {
      //Find which tags the user selected and submit them as a new feed
      // console.log("submitFrontPageFeed from parent");
      let _geo = []; //List of selected geotag ids
      let _interest = []; //List of selected geotag ids

      if (this.geoMain.status == "selected") {
        _geo.push(this.geoMain.id);
      }

      for (const element of this.geoSuggestions) {
        if (element.status == "selected") {
          _geo.push(element.id);
        }
      }

      for (const element of this.cards) {
        if (element.status == "selected") {
          _interest.push(element.id);
        }
      }

      if (_geo.length > 0 && _interest.length > 0) {
        let _submitData = {
          GeoInterests: _geo,
          ProfileId: 0, //Ka brukes den t??
          ProfileName: "Intro Page", //Kanskje gi nytt navn
          TransferType: "add",
          UserInterests: _interest,
        };

        // console.log("Submit data: ", _submitData);
        // console.log("isloggedin: ", this.isLoggedIn);
        // console.log("fp profiles: ", this.TagProfiles);
        if (this.isLoggedIn === true) {
          // console.log("Logged in and ready to submit frontpage");
          this.UPDATE_TAGPROFILES(_submitData)
            .then(() => {
              this.clear();
            })
            .catch((ex) => {
              console.log(ex);
              this.dialog = true; //Cancel or try again choice
            })
            .finally(() => {
              this.GET_TAGPROFILES().then(() => {
                setTimeout(() => this.$router.push("/"), 300);
              });
            });
        } else {
          // console.log("Need to be logged in");
          this.dialog = true; //Cancel or try again choice
        }
      } else {
        //Somehow still not selected at least one interest and geo
        // console.log("Make an snackbar");
        this.dialog = true; //Cancel or try again choice
      }
    },
  },

  mounted() {
    this.clear();
    Promise.all([this.getInterests()]).then(() => {
      // console.log("Inserted mount");
      this.reloaded = true;
      /*
      this.getUserIP().then(res => {
        this.parseUserLoc(res).then((ip) => {
            this.getGeo(ip).then((res) => {
                // console.log("GEO DONE: ", res)
            })
        })
      })
      */
      this.getGeo().then(() => {
        // console.log("Succesfully geo");
      });
    });
  },
};
</script>


<style scoped>
.interestTagCard {
  transition: opacity ease-in-out;
}

.interestTagCard:hover {
  opacity: 0.9;
}

.selectedCard {
  opacity: 0.9;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}

.mainCard {
  font-size: 5em;
  text-align: center;
  top: 50%;
  position: relative;
  transform: translateY(-50%);
}

.mainCardHeart {
  bottom: 5%;
  left: 5%;
  position: relative;
}

#cardSection {
  margin-bottom: 120px;
}
</style>

